import { render, staticRenderFns } from "./bindOrg.vue?vue&type=template&id=70e7d006&scoped=true&"
import script from "./bindOrg.vue?vue&type=script&lang=js&"
export * from "./bindOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e7d006",
  null
  
)

export default component.exports